import { useEffect, useState } from "react";
import { FileSignature } from "lucide-react";
import { useTranslation } from "react-i18next";
import { ScrollArea } from "@/components/ui/scroll-area";
import api from "@/lib/api";

// Scrollable, read-only render of the Host Marketplace Agreement (served from the API in English).
export function HostAgreementView({ doc }) {
  const { t } = useTranslation();
  if (!doc) return <p className="text-slate-400 text-sm p-4">{t("onboarding.agreementLoading")}</p>;
  return (
    <ScrollArea className="h-[38vh] rounded-xl border border-slate-200 bg-slate-50/50 px-5 py-4" data-testid="host-agreement-scroll">
      <p className="flex items-center gap-2 font-heading font-semibold text-slate-900">
        <FileSignature size={16} className="text-blue-600" /> {doc.title}
      </p>
      {doc.intro && <p className="text-slate-600 text-xs leading-relaxed mt-2">{doc.intro}</p>}
      {(doc.sections || []).map((s, i) => (
        <div key={s.title} className="mt-4">
          <h4 className="text-slate-900 font-semibold text-sm">{i + 1}. {s.title}</h4>
          <p className="text-slate-600 text-xs leading-relaxed mt-1 whitespace-pre-line">{s.body}</p>
        </div>
      ))}
    </ScrollArea>
  );
}

export function useHostAgreement() {
  const [doc, setDoc] = useState(null);
  useEffect(() => { api.get("/legal/host-agreement").then((r) => setDoc(r.data)).catch(() => {}); }, []);
  return doc;
}
